import { MAX_FILE_SIZE, SUPPORTED_FORMATS } from '@helpers/constants';
import * as yup from 'yup';

export const podSchema = yup.object({
  document: yup
    .mixed()
    .required('Payment proof is required')
    .test('fileSize', 'File Size is too large', (value: any) =>
      value ? value?.size <= MAX_FILE_SIZE : true
    )
    .test('fileType', 'Unsupported File Format', (value: any) =>
      value ? SUPPORTED_FORMATS.includes(value?.type) : true
    ),
  remarks: yup.string().trim().max(500, 'Max 500 characters').nullable()
  //   delivery_date: yup
  //     .date()
  //     .typeError('Invalid date')
  //     .required('Delivery date is required')
});
